export const constants = {
  routes: {
    main: '/',
    login: '/login',
    register: '/registrar',
    all: '*'
  },
  localStorageKey: 'user'
}
